<template>
  <div class="overflow-x-auto">
    <table class="w-full border border-gray-300 dark:border-gray-600 text-sm text-left">
      <thead class="bg-gray-100 dark:bg-gray-800">
        <tr>
          <th class="border px-2 py-1">Type</th>
          <th class="border px-2 py-1">Purpose</th>
          <th class="border px-2 py-1">Storage Method</th>
          <th class="border px-2 py-1">Duration</th>
          <th class="border px-2 py-1">Personal Data Stored</th>
        </tr>
      </thead>
      <tbody>
        <tr class="even:bg-gray-50 dark:even:bg-gray-900">
          <td class="border px-2 py-1">Authentication Cookie (JWT)</td>
          <td class="border px-2 py-1">Maintains secure login session</td>
          <td class="border px-2 py-1">Cookie</td>
          <td class="border px-2 py-1">Until logout or token expiry</td>
          <td class="border px-2 py-1">None directly (token only)</td>
        </tr>
        <tr class="even:bg-gray-50 dark:even:bg-gray-900">
          <td class="border px-2 py-1">Site Preferences</td>
          <td class="border px-2 py-1">Saves interface and site settings</td>
          <td class="border px-2 py-1">Local Storage</td>
          <td class="border px-2 py-1">Persistent (until cleared by user)</td>
          <td class="border px-2 py-1">None</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
